import { Card, Text, Image, Box, Heading, Flex, Icon } from "@chakra-ui/react"
import { Link } from "@tanstack/react-router"
import { PublicationPreviewProps } from "../../api/landingpage"
import { FaRegCalendarDays } from "react-icons/fa6"


const PublicationSearchPreview = ({publication} : PublicationPreviewProps) => {
  return (
    <Link to="/$slug" params={{ slug: publication.classic_id }}>
        <Heading size="lg" mb={4}>{publication.title}</Heading>

        <Card.Root flexDirection="row" overflow="hidden" border="none" borderRadius="none">
            {publication.lead_image &&
                <Image
                    src={publication.lead_image.path.replace(/-(LG)\./, "-SM.")}
                    alt={publication.lead_image.file_name}
                    w="10em"
                    h="10em"
                    mr={5}
                    objectFit="cover"
                    objectPosition={`${publication.lead_image.focal_point ? publication.lead_image.focal_point[0] : 50}% ${publication.lead_image.focal_point ? publication.lead_image.focal_point[1] : 50}%`}
                />
            }

            <Box>
                <Card.Body p={0}>
                    {publication.lead ? (
                        <Card.Description
                            lineClamp={3}
                            hyphens="auto"
                            data-testid="publication_card_desc"
                            color="black"
                            fontSize={16}
                        >
                        {publication.lead}
                        </Card.Description>
                    ) : (
                        <Card.Description
                            lineClamp={3}
                            hyphens="auto"
                            data-testid="publication_card_desc"
                            color="black"
                            fontSize={16}
                            dangerouslySetInnerHTML={{ __html: publication.content }}
                        />
                    )}

                    <Flex alignContent="center" my={5}>
                        <Icon as={FaRegCalendarDays} size="md" color="main" />
                        <Text ml={4} fontSize={14}>
                            {new Intl.DateTimeFormat("de-CH", {
                                day: "numeric",
                                month: "long",
                                year: "numeric",
                                timeZone: "Europe/Zurich",
                            }).format(new Date(publication.publication_dt))}
                        </Text>
                    </Flex>
                </Card.Body>
            </Box>
        </Card.Root>
    </Link>
  )
}

export default PublicationSearchPreview
